import React, { useEffect, useState } from 'react';
import { NotFound, SidebarContainer } from '../../components';
import { useParams } from 'react-router-dom';
import { UserClass } from '../../AdminClasses';
import { useTitle } from '@arema/components/Hooks';
import { useUser } from '../../AdminHooks';
import { USER_LOGINS } from '../CatalogList';
import Catalog from '../Catalog';
import UserDetails from './UserDetails';
import UserSales from './UserSales';
import UserEvents from './UserEvents';

var UserContainer = ()=>{
	var { setTitle } = useTitle();
	var { user, hasAccess } = useUser();
	var [userData, setUserData] = useState<UserClass>(null);
	var params = useParams<{ id: string }>();
	
	if(!params || !params.id || Number.isNaN(parseInt(params.id))){
		return <NotFound />
	}
	
	return <SidebarContainer 
		header={'Usuario'}
		routes={[
			{ url: `/users/${params.id}`, component: UserDetails },
			{ url: `/users/${params.id}/ventas`, component: UserSales },
			{ url: `/users/${params.id}/logins`, component: UserDetails },
			{ url: `/users/${params.id}/events`, component: UserEvents },
			{ url: `/users/${params.id}/access`, render: <Catalog options={USER_LOGINS(user, hasAccess, params.id)} key={'user-access'} /> },
		]}
		routeParams={{
			onUserData: (ud: UserClass)=>{
				if(!ud) return;
				setUserData(ud);
				setTitle(`Usuario: ${ud.first_name} ${ud.last_name}`);
			}
		}}
		getTitle={()=>{
			return userData ? `Usuario: ${userData.first_name} ${userData.last_name}` : 'Usuario'
		}}
		items={[
			{ text: 'Usuario', 		icon: 'user', 					url: `/users/${params.id}` },
			{ text: 'Empresarios',	icon: 'chart-line',			url: `/users/${params.id}/events` },
			{ text: 'Accesos', 		icon: 'history', 				url: `/users/${params.id}/access` },
			// { text: 'Ventas', 	icon: 'cash register', 		url: `/users/${params.id}/ventas` },
			// { text: 'Accesos', 	icon: 'sign in', 				url: `/users/${params.id}/logins` },
		]}
	/>
}

export default UserContainer;